export default __webpack_public_path__ + "static/media/Collect resources to fuel your succes.8f4d5420.webm";